@if (isStakesAvailable) {
    <div class="quickbet-quick-stake" [ngClass]="{ disabled: disabled }" data-crlat="quickStakePanel">
        @for (item of quickStakeItems; track trackByIndex(stakeIndex); let stakeIndex = $index) {
            <div class="qb-quick-stake-item price-button-{{ stakeIndex }}" (click)="setQuickStake(item, stakeIndex)" data-crlat="quickStake.key">
                <span> <span [textContent]="quickStakePrefix"></span><span [innerHTML]="item"></span> </span>
            </div>
        }
        <!-- Use Free Bet -->
        @if (
            quickStakeVisible &&
            ((freebetsList && freebetsList.length > 0) || (betPackList && betPackList.length > 0) || (fanzoneList && fanzoneList.length > 0))
        ) {
            <div class="qb-quick-stake-item" [ngClass]="selectedFreeBet ? 'qb-free-bet-sel' : 'qb-fb-toggle fb-ripple'">
                <lazy-component
                    moduleUri="@freebetsModule/freebets.module#FreebetsModule"
                    [inputs]="{
                        freeBets: freebetsList,
                        selected: selectedFreeBet,
                        freebetsConfig,
                        isBoostEnabled,
                        isSelectionBoosted,
                        canBoostSelection,
                        showOnDigitKeyborad: true,
                        betPackList,
                        fanzoneList,
                    }"
                    [outputs]="['selectedChange']"
                    (event)="onFreebetChange($event)"
                    entryComponent="FreeBetToggleComponent">
                </lazy-component>
            </div>
        }
    </div>
}
